import React from "react";

function AllPlayersStats({ players, shortPatch }) {
    return (
<div className="all-player-stats">
    {Array.from({ length: 5 }, (_, i) => (
    <div className="all-player-stats-line">
        <div className="all-player-stats-flex">
            <div className="all-player-stats-text">
                <p className="all-player-stats-pseudo">{players[i].summonerName}</p>
                <p className="all-player-stats-kda all-player-low-padding">{players[i].kills} / {players[i].deaths} / {players[i].assists}</p>
                <div className="all-player-stats-hp-container" >
                    <div className="all-player-stats-hp-fill" style={{ width: `${Math.round(players[i].currentHealth / players[i].maxHealth * 100)}%`}}></div>
                    <p className="hp-text">{players[i].currentHealth}/{players[i].maxHealth}</p>
                </div>
            </div>

            <div className="all-player-stats-div-gold">
                <p className="all-player-stats-gold">{players[i].totalGold}</p>
                <p className="all-player-stats-cs">{players[i].creepScore} CS</p>
            </div>

            <div className="all-player-stats-div-img-left">
                <div className="all-player-stats-champion">
                    <img src={`https://ddragon.leagueoflegends.com/cdn/${shortPatch}.1/img/champion/${players[i].championId}.png`} alt={`${players[i].championId}`}/>
                </div>
                <div className="all-player-stats-level all-player-stats-level-left">
                    <p>{players[i].level}</p>
                </div>
            </div>
        </div>
        <div className="all-player-stats-vs">
            <p>
                <img src="gold_left.png" alt="left gold" classNameName="goldArrow" style={{opacity: players[i].totalGold > players[i+5].totalGold ? 1 : 0,}}/>
                            {Math.abs(players[i].totalGold - players[i+5].totalGold)}
                <img src="gold_right.png" alt="right gold" classNameName="goldArrow" style={{opacity: players[i].totalGold < players[i+5].totalGold ? 1 : 0,}}/>
            </p>
        </div>
        <div className="all-player-stats-flex">
            <div className="all-player-stats-div-img-right">
                <div className="all-player-stats-champion">
                    <img src={`https://ddragon.leagueoflegends.com/cdn/${shortPatch}.1/img/champion/${players[i+5].championId}.png`} alt={`${players[i+5].championId}`}/>
                </div>
                <div className="all-player-stats-level all-player-stats-level-right">
                    <p>{players[i].level}</p>
                </div>
            </div>

            <div className="all-player-stats-div-gold">
                <p className="all-player-stats-gold">{players[i+5].totalGold}</p>
                <p className="all-player-stats-cs all-player-low-padding">{players[i+5].creepScore} CS</p>
                <div className="all-player-stats-hp-container" >
                    <div className="all-player-stats-hp-fill" style={{ width: `${Math.round(players[i+5].currentHealth / players[i+5].maxHealth * 100)}%` }}></div>
                    <p className="hp-text">{players[i+5].currentHealth}/{players[i+5].maxHealth}</p>
                </div>
            </div>

            <div className="all-player-stats-text">
                <p className="all-player-stats-pseudo">{players[i+5].summonerName}</p>
                <p className="all-player-stats-kda all-player-low-padding" >{players[i+5].kills} / {players[i+5].deaths} / {players[i+5].assists}</p>

            </div>

        </div>

    </div>
    ))}
</div>)

}


export default AllPlayersStats;
